<template>
  <div class="upload-container">
    <el-card class="upload-card">
      <!-- <h2>无感认证管理</h2>-->
      <div id="centerTitle">公安数据比对平台（身故）</div>
      <!-- <div>
        <span class="auth-tip">注:收费标准为3元/人</span>
      </div> -->
      <!-- 上传数据部分 -->
      <div class="section-container">
        <h3>数据上传</h3>
        <el-form ref="uploadForm" :model="formData" label-position="top">
          <el-row :gutter="20">
            <!-- 第一步：下载模板 -->
            <el-col :span="8">
              <el-form-item label="第一步：下载模板">
                <el-button type="primary" @click="handleDownloadTemplate" icon="el-icon-download">
                  下载Excel模板
                </el-button>
                <div class="step-tip">请先下载模板，按照模板格式填写数据</div>
              </el-form-item>
            </el-col>

            <!-- 第二步：选择地区 -->
            <el-col :span="8">
              <el-form-item label="第二步：选择地区">
                <Candode v-on:childByValue="childByValue" :address="townList"></Candode>
                <div class="step-tip">请选择省、市、县三级地区</div>
              </el-form-item>
            </el-col>

            <!-- 第三步：上传文件 -->
            <el-col :span="8">
              <el-form-item label="第三步：上传文件">
                <el-upload ref="upload" :action="uploadUrl" :auto-upload="false" :before-upload="beforeUpload"
                  :on-change="handleFileChange" :on-remove="handleFileRemove" :file-list="fileList"
                  :show-file-list="true" class="upload-demo" accept=".xls,.xlsx">
                  <el-button slot="trigger" type="success" :disabled="fileList.length >= 1">
                    选择 Excel 文件
                  </el-button>
                </el-upload>
                <div class="step-tip">请选择填写好的Excel文件</div>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 上传按钮 -->
          <div class="action-buttons">
            <el-button type="primary" @click="submitUpload" :disabled="!selectedFile || !hasRegionValues"
              icon="el-icon-upload">
              开始上传数据
            </el-button>
          </div>

          <!-- 提示信息 -->
          <div class="upload-tips">
            <el-alert title="温馨提示：" type="info" :closable="false" show-icon>
              <div class="tip-content">
                <p class="auth-tip">1. 请严格按照模板格式填写数据</p>
                <p class="auth-tip">2. 数据量较大时，处理时间可能较长，请耐心等待</p>
                <p class="auth-tip">3. 核验完成后，结果可在列表中导出</p>
              </div>
            </el-alert>
          </div>
        </el-form>
      </div>
      <!-- 上传记录表格 -->
      <div class="section-container">
        <h3>上传记录</h3>
        <el-table v-loading="loading" :data="uploadRecords" stripe border style="width: 100%; overflow-x: auto;"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            fontWeight: 'bold'
          }">
          <!-- 批次号 -->
          <el-table-column prop="batchNumber" label="批次号" min-width="180" show-overflow-tooltip align="center" />

          <!-- 数据总数 -->
          <el-table-column prop="checkNumber" label="数据总数" min-width="120" align="center" />

          <!-- 上传日期 -->
          <el-table-column label="上传日期" min-width="160" align="center" prop="createTime" />

          <!-- 上传状态 -->
          <el-table-column label="状态" min-width="120" prop="upStatus" :formatter="upStatusFormatter" align="center" />

          <!-- 操作 -->
          <el-table-column label="操作" min-width="180" align="center">
            <template slot-scope="scope">
              <div class="table-action-btns">
                <el-button v-if="scope.row && scope.row.upStatus == 1" type="danger" size="small"
                  @click="checkSurvivalData(scope.row.batchNumber)" icon="el-icon-refresh">
                  开始无感认证
                </el-button>
                <el-button v-if="scope.row && scope.row.upStatus == 3" type="primary" size="small"
                  @click="handleDownloadRecord(scope.row.batchNumber)" icon="el-icon-download">
                  下载结果
                </el-button>
                <el-button v-if="scope.row && scope.row.upStatus == 3" type="primary" size="small"
                  @click="handleDownloadVerify(scope.row)" icon="el-icon-download">
                  核验报告
                </el-button>
              </div>
            </template>
          </el-table-column>

          <!-- 备注 -->
          <el-table-column prop="memo" label="备注" min-width="200" show-overflow-tooltip />
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination class="pone" :page-size="queryParams.pageSize" layout="total, prev, pager, next, jumper"
            :total="total" :current-page.sync="queryParams.pageNum" @current-change="handlePageChange" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import Candode from "../Core/candode";
import { format } from "crypto-js";
import Cookies from "js-cookie";

export default {
  components: {
    Candode,
  },
  name: "checkSurvival",
  data() {
    return {
      lastFour: "",
      uploadedFile: false,
      loading: false, // 加载状态
      total: 0, // 数据总数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      townList: [],
      selectedFile: null,
      fileList: [],
      selectedMonth: null, // 新增：选中的年月
      formData: {}, // 添加 formData 对象
      uploadUrl: "https://server.weface.com.cn/sensorlessAuthentication/survival/uploadExcel",
      checkSurvivalUrl: "https://server.weface.com.cn/sensorlessAuthentication/survival/checkSurvival",
      downloadUrl: "https://server.weface.com.cn/sensorlessAuthentication/survival/downloadData",
      downloadTemplateUrl: "https://server.weface.com.cn/sensorlessAuthentication/survival/downloadTemplate",// 新增：下载模板接口
      queryRecords: "https://server.weface.com.cn/sensorlessAuthentication/survival/queryUploadRecords",
      fetchStatusUrl: "https://server.weface.com.cn/sensorlessAuthentication/survival/fetchStatus",
      userPhone: 'https://back.rensheju.com/user/findPhone',
      // uploadUrl: " http://172.16.10.114:8081/survival/uploadExcel",
      // checkSurvivalUrl: " http://172.16.10.114:8081/survival/checkSurvival",
      // downloadUrl: " http://172.16.10.114:8081/survival/downloadData", // 新增：下载接口
      // downloadTemplateUrl: " http://172.16.10.114:8081/survival/downloadTemplate", // 新增：下载模板接口
      // queryRecords: " http://172.16.10.114:8081/survival/queryUploadRecords",
      // fetchStatusUrl: "http://172.16.10.114:8081/survival/fetchStatus",// 新增：fetchStatusUrl
      // userPhone: 'http://172.16.10.114:8082/user/findPhone',
      uploadRecords: [], // 初始化为空数组
    };
  },
  created() {
    const list = JSON.parse(sessionStorage.getItem("list") || "{}");
    if (list.province) {
      this.townList = [list.province];
      if (list.city) this.townList.push(list.city);
      if (list.country) this.townList.push(list.country);
      if (list.town) this.townList.push(list.town);
    }
    this.getList(); // 确保上传记录数据被填充
    this.checkUploadStatus(); // 检查文件上传状态
  },
  computed: {
    hasRegionValues() {
      return this.townList && this.townList.length >= 3;
    }
  },
  methods: {
    checkUploadStatus() {
      const params = {
        opUserName: window.localStorage.getItem("userName")
      };
      fetch(this.fetchStatusUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })
        .then(response => response.json())
        .then(data => {
          if (data.state === 200) {
            this.uploadedFile = true;
          }
          console.log('Uploaded file status:', this.uploadedFile);
        })
        .catch(error => {
          console.error('Error updating uploaded file status:', error);
        });
    },

    childByValue(val) {
      this.townList = val;
    },
    // 选择文件
    handleFileChange(file) {
      if (this.fileList.length >= 1) {
        this.$message.warning("只能上传一个 Excel 文件！");
        return;
      }
      this.selectedFile = file.raw;
      this.fileList = [file]; // 只保留最新的文件
    },
    upStatusFormatter(row) {
      if (!row || typeof row.upStatus === 'undefined') return '-';
      const txnStatuses = {
        0: "上传中",
        1: "上传成功",
        2: "核验中",
        3: "核验完成",
      };
      return txnStatuses[row.upStatus] || "未知";
    },

    // 获取上传记录数据（包含分页）
    async getList() {
      this.loading = true;
      try {
        const response = await axios.post(this.queryRecords, {
          opUserName: window.localStorage.getItem("userName"),
          source: 0,
          pageNum: this.queryParams.pageNum,
          pageSize: this.queryParams.pageSize,
        });
        console.log("response----->" + response.data);
        if (response.data.state === 200) {
          console.log('uploadRecords:', response.data.result, Array.isArray(response.data.result), response.data.result.length, typeof response.data.result[0]);
          this.uploadRecords = response.data.result.data;
          this.total = response.data.result.total;
        } else {
          this.$message.error(response.data.describe);
        }
      } catch (error) {
        this.$message.error(`获取上传记录失败: ${error.message}`);
      } finally {
        this.loading = false;
      }
    },

    // 删除文件
    handleFileRemove(file) {
      this.selectedFile = null;
      this.fileList = []; // 清空文件列表
    },

    // 上传前检查
    beforeUpload(file) {
      const isExcel = /\.(xls|xlsx)$/.test(file.name);
      if (!isExcel) {
        this.$message.error("只能上传 Excel 文件（.xls 或 .xlsx）！");
        return false;
      }
      return true;
    },

    // 提交上传
    async submitUpload() {
      if (!this.selectedFile) {
        this.$message.error("请先选择 Excel 文件！");
        return;
      }

      // 先检查文件类型
      if (!/\.(xls|xlsx)$/.test(this.selectedFile.name)) {
        this.$message.error("只能上传 Excel 文件（.xls 或 .xlsx）！");
        return;
      }

      // 检查地区选择是否完整（至少3级：省、市、县）
      if (!this.townList || this.townList.length < 3) {
        this.$message.error("请完整选择省、市、县三级地区！");
        return;
      }

      try {
        await this.$confirm(
          'Excel文件格式要求：\n\n1. 第一行为标题行\n2. 第二行开始为数据行\n3. 列顺序必须为：序号、姓名、身份证号、类型\n4. 如因格式错误导致核验失败，由操作人负责',
          '确认文件格式',
          {
            confirmButtonText: '确认格式无误并上传',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
        console.log("uploadedFile1----->" + this.uploadedFile);
        if (this.uploadedFile) {
          // console.log("uploadedFile2----->"+uploadedFile);
          await this.$confirm(
            '您今日已经上传并处理过数据，确认是否仍需处理这批数据？',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }
          );
        }

        const formData = new FormData();
        formData.append("file", this.selectedFile)
        formData.append(
          "uploadFileExcelDTO",
          JSON.stringify({
            opCity: this.townList[1] ? this.townList[1].split(",")[1] : "",
            opCounty: this.townList[2] ? this.townList[2].split(",")[1] : "",
            opUserName: window.localStorage.getItem("userName"),
            source: 0,
          }));

        const response = await axios.post(this.uploadUrl, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.state === 200) {
          this.$message({
            message: "文件上传成功，等待数据核验完成后下载结果！",
            type: "success",
            duration: 3000,
          });
          this.fileList = [];
          this.selectedFile = null;
          this.getList(); // 刷新上传记录
        } else {
          this.$message.error(`上传失败: ${response.data.describe}`);
        }
      } catch (error) {
        if (error !== 'cancel') { // 用户点击取消时不显示错误
          this.$message.error(`请求失败: ${error.message}`);
        }
      }
    },
    async checkSurvivalData(batchNumber) {
      const opUserName = window.localStorage.getItem("userName");
      if (!opUserName) {
        this.$message.error("无法获取用户名，请重新登录！");
        return;
      }

      try {
        const response = await axios.post(this.checkSurvivalUrl, {
          opUserName: opUserName,
          batchNumber: batchNumber,
          source: 0,
        });

        if (response.data.state === 200) {
          this.$message.success(`无感认证已启动:${response.data.describe}`);
        } else {
          this.$message.error(`检测失败: ${response.data.describe}`);
        }
      } catch (error) {
        this.$message.error(`请求失败: ${error.message}`);
      }
    },
    // 新增：处理下载
    async handleDownloadTemplate() {
      try {
        const response = await axios.get(this.downloadTemplateUrl, {
          params: {
            userName: window.localStorage.getItem("userName")
          },
          responseType: 'blob'
        });

        let fileName = `survival_data_${this.selectedMonth}.xlsx`; // 默认
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
          const asciiMatch = disposition.match(/filename="?([^"]+)"?/);

          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch) {
            fileName = asciiMatch[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('模板下载成功');
      } catch (error) {
        this.$message.error(`模板下载失败: ${error.message}`);
      }
    },

    async fetchUploadRecords() {
      try {
        const response = await axios.post(this.queryRecords, {
          opUserName: window.localStorage.getItem("userName"),
          source: 0
        });
        if (response.data.state === 200) {
          this.uploadRecords = response.data.result;
        }
        return
      } catch (error) {
        this.$message.error(`获取上传记录失败: ${error.message}`);
      }
    },
    async handleDownloadRecord(batchNumber) {
      try {
        // 先获取手机号
        const phoneResponse = await axios.post(this.userPhone,
          JSON.stringify({
            data: {
              pageNum: 1,
              pageSize: 50,
              columnFilters: [{
                name: window.localStorage.getItem("userName")
              }]
            }
          }), {
          headers: {
            'Content-Type': 'application/json',
            'token': Cookies.get('token')
          }
        })

        // console.log(phoneResponse, 'phoneResponse')

        let phoneNum = '';
        if (phoneResponse.data && phoneResponse.data.data && phoneResponse.data.data.content) {
          const userList = phoneResponse.data.data.content;
          if (userList.length > 0) {
            // 给发送请求的手机号赋值
            phoneNum = userList[0].mobile || '';
            // 给后四位手机号赋值
            this.lastFour = phoneNum.slice(-4);
          }
        }

        // console.log(phoneNum, 'phoneNum')
        // return

        const response = await axios.get(this.downloadUrl, {
          params: {
            batchNumber: batchNumber,
            opUserName: window.localStorage.getItem("userName"),
            source: 0,
            phoneNum: phoneNum
          },
          responseType: 'blob'
        });

        let fileName = `survival_data_${batchNumber}.xlsx`;
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
          const asciiMatch = disposition.match(/filename="?([^"]+)"?/);

          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch) {
            fileName = asciiMatch[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message({
          message: `文件已下载完成。如有绑定手机号，本次文件将加密处理，密码短信将发送至尾号为${this.lastFour}的手机；未绑定手机号或未收到短信，请联系客服处理`,
          type: 'success',
          duration: 4000
        });
      } catch (error) {
        this.$message.error(`下载失败: ${error.message}`);
      }
    },
    // 获取状态对应的标签类型
    getStatusType(status) {
      if (typeof status === 'undefined') return 'info';
      const statusTypes = {
        0: 'info',    // 上传中
        1: 'success', // 上传成功
        2: 'danger',  // 上传失败
        3: 'success'  // 核验完成
      };
      return statusTypes[status] || 'info';
    },

    // 重试上传
    async handleRetryUpload(row) {
      try {
        await this.$confirm('确定要重新上传该批次数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        const response = await axios.post(this.uploadUrl + '/retry', {
          batchNumber: row.batchNumber,
          opUserName: window.localStorage.getItem("userName"),
          source: 0
        });

        if (response.data.state === 200) {
          this.$message.success('重试上传已启动');
          this.getList(); // 刷新列表
        } else {
          this.$message.error(response.data.describe);
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(`重试失败: ${error.message}`);
        }
      }
    },

    // 查看详情
    handleViewDetails(row) {
      this.$router.push({
        path: '/upload-details',
        query: {
          batchNumber: row.batchNumber
        }
      });
    },

    handlePageChange(page) {
      this.queryParams.pageNum = page;
      this.getList();
    },

    // 下载核验报告
    async handleDownloadVerify(row) {
      try {
        const params = [
          "batchNumber=" + encodeURIComponent(row.batchNumber),
          "opUserName=" + encodeURIComponent(window.localStorage.getItem("userName")),
          "source=0",
          "app=mz"
        ].join("&");
        // 测试环境接口地址（如需切换，取消下行注释）
        // const url = `http://172.16.10.114:8081/survival/downloadVerify?${params}`
        // 线上环境接口地址（默认使用）
        const url = `https://server.weface.com.cn/sensorlessAuthentication/survival/downloadVerify?${params}`;

        const response = await axios.get(url, { responseType: "blob" });

        let fileName = `核验报告_${row.batchNumber}.pdf`;
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/);
          const asciiMatch = disposition.match(/filename="?([^"]+)"?/);
          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch) {
            fileName = asciiMatch[1];
          }
        }

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('核验报告下载成功');
      } catch (error) {
        this.$message.error(`核验报告下载失败: ${error.message}`);
      }
    },
  }
}



</script>

<style scoped>
.upload-container {
  max-width: 100%;
  max-height: 100%;
  margin: 20px auto;
}

.upload-card {
  padding: 24px;
}

.section-container {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.section-container h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #333;
  font-size: 16px;
}

.action-buttons {
  margin-top: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.auth-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.auth-tip {
  color: #cf2020;
  /* font-size: 18px; */
  font-style: italic;
  display: block;
  text-align: left;
  margin-top: 10px;
}

.action-buttons .el-button {
  margin: 0 10px;
}

.upload-demo {
  width: 100%;
}

#centerTitle {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  margin: 40px 0;
  color: #333;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-table {
  margin-top: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-table .el-tag {
  margin: 2px;
}

.el-button+.el-button {
  margin-left: 8px;
}

.el-table .cell {
  white-space: nowrap;
}

.step-tip {
  font-weight: bold;
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

.upload-tips {
  margin-top: 20px;
}

.tip-content {
  font-size: 13px;
  line-height: 1.6;
}

.tip-content p {
  margin: 5px 0;
}

.table-action-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  align-items: center;
}

@media (max-width: 600px) {
  .table-action-btns {
    flex-direction: column;
    gap: 4px;
    align-items: center;
  }

  .table-action-btns .el-button {
    min-width: 80px;
    font-size: 12px;
    padding: 6px 16px;
    width: auto;
    box-sizing: border-box;
    margin: 0 auto;
  }
}

.el-button+.el-button,
.el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/checkSurvival.vue